import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MailmergeNonadminViewerComponent } from './mailmerge-nonadmin-viewer.component';
import { TextViewerModule } from '../../text-viewer/index';

@NgModule({
  declarations: [MailmergeNonadminViewerComponent],
  imports: [
    CommonModule,
    TextViewerModule,
  ],
  exports:[
    MailmergeNonadminViewerComponent,
    CommonModule,
    TextViewerModule,
  ],
})
export class MailmergeNonadminViewerModule { }
